import { call } from 'redux-saga/effects';
import removeIncomingCall from '../../callSessions/removeIncomingCall/removeIncomingCall';

export default function* ignoreCall({ payload: { call: callSession, statusCode, signalHid = true } }) {
  callSession.ignore(signalHid, statusCode);
  yield call(removeIncomingCall, { payload: callSession.id });
}
